"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var redux_1 = require("redux");
var redux_thunk_1 = tslib_1.__importDefault(require("redux-thunk"));
var reducers_1 = tslib_1.__importDefault(require("./reducers"));
var defaultReducer = function (state) { return state; };
var createAppStore = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.middleware, middleware = _a === void 0 ? [] : _a, _b = options.reducers, reducers = _b === void 0 ? {} : _b, _c = options.rootReducer, rootReducer = _c === void 0 ? defaultReducer : _c, enhancer = options.enhancer, _d = options.state, state = _d === void 0 ? {} : _d;
    // Redux devtools only run if the extension is present in the browser
    // https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
    // @ts-ignore ignore errors from redux devtools
    var composeFunc = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        /* istanbul ignore next */
        // @ts-ignore ignore errors from redux devtools
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            actionsBlacklist: ['dataFetched', 'dataFetching'],
            maxAge: 100,
        }) : redux_1.compose;
    var enhancers = [redux_1.applyMiddleware.apply(void 0, tslib_1.__spread([redux_thunk_1.default], middleware))];
    if (enhancer) {
        enhancers.push(enhancer);
    }
    var reducerMap = reducers_1.default(reducers);
    return redux_1.createStore(function (s, action) { return rootReducer(reducerMap(s, action), action); }, state, composeFunc.apply(void 0, tslib_1.__spread(enhancers)));
};
exports.createAppStore = createAppStore;
exports.default = createAppStore;
//# sourceMappingURL=store.js.map